import React, { useContext } from 'react';
import { AuthContext } from '../authProvider/AuthProvider';
import { EXTERNAL_ROUTES } from '../../static/Urls';

function useAuth() {
  return useContext(AuthContext);
}

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const redirectToLogin = () => window.open(EXTERNAL_ROUTES.LOGIN_PATH, '_self');
  const auth = useAuth();
  if (!auth.user) {
    return <></>;
  }
  if (auth.user.isAuthenticated) {
    return children;
  }

  return redirectToLogin() && <></>;
};

export { ProtectedRoute };
